// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountingExportListController = function ($rootScope, $modal, $scope, AccountingExport, AccountingStatus,
    AccountingOperations, AccountingExportWrapper, $http, gettextCatalog, gettext, DatepickerUtils, PUtill) {
    var filterKind = "Export"; // "Preview" is not supported yet
    var pageSizeRows = 20;
    var pageRefreshRateMs = 10000; 
    var exportInProgress = false;
    $scope.missingConfiguration = false;

    $scope.lastExport = {
        statusAvailable: false,
        status: "",
        error: ""
    };

    $scope.exports = new AccountingExportWrapper();
    $scope.current = $scope.exports.firstOrDefault();

    $scope.isValidStatus = function (file) {
        var expected = "Finished, InProgress, Queued";
        return expected.indexOf(file.Status) > -1;
    };

    function saveCurrentExport() {
        if ($scope.current) {
            $scope.savedExportId = $scope.current.Id;
        }
    }

    /* UI functions */

    $scope.setCurrentExport = function (id) {
        $scope.current = $scope.exports.byId(id);
    }

    function createFile(reportId, format) {
        AccountingOperations.createFile(reportId, format,
            function () {
                saveCurrentExport();
                updatePage();
            }, function (error) {
                saveCurrentExport();
                updatePage();
            });
    }

    function exportPostings(kind, format, endDate) {
        let endMoment = moment(DatepickerUtils.backToBrowserTimezone(endDate)).tz(PUtill.BerlinTzName);
        let endString = PUtill.toShortDateString(endMoment);
        AccountingOperations.exportPostings(kind, format, endString,
            function () {
                saveCurrentExport();
                updatePage();
            }, function () {
                saveCurrentExport();
                updatePage();
            });
    };

    $scope.download = function (id) {
        AccountingOperations.downloadFile(id,
            function (downloadInfo) {
                $scope.downloadFile(downloadInfo.data.Url);
            }, function (error) {
                saveCurrentExport();
                updatePage();
            });
    };

    function updateStatus() {
        var accountingStatus = AccountingStatus.get(function () {
            if (!!accountingStatus) {
                if (!!accountingStatus.CurrentExportRequest) {
                    $scope.lastExport.statusAvailable = true;
                    $scope.lastExport.status = accountingStatus.CurrentExportRequest.Status;
                    $scope.lastExport.error = accountingStatus.CurrentExportRequest.ErrorMessage;

                    if ($scope.lastExport.status == "InProgress" || $scope.lastExport.status == "Queued") {
                        exportInProgress = true;
                    }
                } else {
                    if (exportInProgress == true) {
                        exportInProgress = false;
                        load();
                    }

                    $scope.lastExport.statusAvailable = false;
                    $scope.lastExport.status = "";
                    $scope.lastExport.error = "";
                }

                $scope.missingConfiguration = accountingStatus.Status === 'IncompleteConfiguration';
            }
        });
    }
 
    function load() {
        function getSearchParams() {
            return {
                includeFiles: true,
                kind: filterKind,
            };
        }

        $scope.paging = $scope.paginator(function (options, callback) {
            return AccountingExport.query(options, function () {
                callback();
                $scope.wasSearching = false; 

                if (!$scope.exports) {
                    $scope.exports = new AccountingExportWrapper();
                }
                
                $scope.exports.load($scope.paging.items);
                $scope.current = $scope.exports.firstOrDefault();

                updateStatus();
            });
        }, getSearchParams(), pageSizeRows);
    }

    /* UI Dialogs */

    $scope.isCreateExportDisabled = function () {
        return $scope.missingConfiguration;
    };

    $scope.createExportDlg = function () {
        var modalInstance = $modal.open({
            templateUrl: 'partials/controls/ok-cancel-modal.html' + $rootScope.linkVersion,
            controller: ['$scope', '$uibModalInstance', 'gettextCatalog', 'gettext', function ($scope, $modalInstance, gettextCatalog, gettext) {
                $scope.title = gettextCatalog.getString(gettext("Create new export"));
                $scope.message = "";
                $scope.contentTemplate = 'partials/controls/accounting-export-create-export.html' + $rootScope.linkVersion;
                $scope.ok = function () {
                    if (!$scope.data.format || !$scope.data.exportDate) {
                        return;
                    }
                    delete $scope.data.notification;
                    $modalInstance.close({ result: 'ok', data: $scope.data });
                };
                $scope.cancel = function () {
                    $modalInstance.dismiss('cancel');
                };
                $scope.data = {
                    format: "",
                    exportDate: "",
                    notification: gettextCatalog.getString(gettext("please select data"))
                }
            }],
            windowClass: "fade in",
            resolve: { data: function () { return $scope.data; } }
        });
        modalInstance.result.then(function (response) {
            if (response.result === 'ok') {
                exportPostings(filterKind, response.data.format, response.data.exportDate);
            } 
        });
    }

    $scope.createFileDlg = function () {
        var modalInstance = $modal.open({
            templateUrl: 'partials/controls/ok-cancel-modal.html' + $rootScope.linkVersion,
            controller: ['$scope', '$uibModalInstance', 'gettextCatalog', 'gettext', function ($scope, $modalInstance, gettextCatalog, gettext) {
                $scope.title = gettextCatalog.getString(gettext("Create new file"));
                $scope.message = "";
                $scope.contentTemplate = 'partials/controls/accounting-export-create-file.html' + $rootScope.linkVersion;
                $scope.ok = function () {
                    if (!$scope.data.format)
                        return;

                    delete $scope.data.notification;
                    $modalInstance.close({ result: 'ok', data: $scope.data });
                };
                $scope.cancel = function () {
                    $modalInstance.dismiss('cancel');
                };
                $scope.data = {
                    format: "",
                    notification: gettextCatalog.getString(gettext("please select data"))
                }
            }],
            windowClass: "fade in",
            resolve: { data: function () { return $scope.data; } }
        });
        modalInstance.result.then(function (response) {
            if (response.result === 'ok') {
                createFile($scope.current.Id, response.data.format);
            } 
        });
    }

    function updatePage() {

        var exportings = AccountingExport.query({
            includeFiles: true,
            kind: filterKind,
            from: $scope.exports.firstRowId,
            take: pageSizeRows
        }, function (response) {
            if (!$scope.exports) {
                $scope.exports = new AccountingExportWrapper();
            }
            $scope.paging.items = response;
            $scope.exports.load($scope.paging.items);

            if (!!$scope.savedExportId) {
                $scope.current = $scope.exports.byId($scope.savedExportId);
                $scope.savedExportId = null;
            } else {
                $scope.current = $scope.exports.firstOrDefault();
            }
            updateStatus();
        });
    }

     var source = Rx.Observable
         .interval(pageRefreshRateMs)
         .timeInterval();

    var subscription = source.subscribe(
        function (x) {

            if (!$scope.current) {
                return;
            }

            saveCurrentExport();
            updatePage();

        });

    $scope.$on("$destroy", function handler() {
        subscription.dispose();
    });

    load();
};
AccountingExportListController.$inject = ['$rootScope', '$uibModal', '$scope', 'AccountingExport', 'AccountingStatus',
    'AccountingOperations', 'AccountingExportWrapper', '$http', 'gettextCatalog', 'gettext', 'DatepickerUtils', 'PUtill'];
